var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 319,
    viewBox: "0 0 489 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6058 209.562C93.1939 282.47 168.847 318.987 244.5 318.987C320.153 318.987 395.806 282.47 453.394 209.562L486.23 167.991C489.923 163.19 489.923 155.608 486.23 150.933L453.394 109.362C338.218 -36.4539 150.782 -36.4539 35.6058 109.362L2.76962 150.933C-0.923206 155.735 -0.923206 163.316 2.76962 167.991L35.6058 209.562ZM324 158.5C324 202.407 288.407 238 244.5 238C200.593 238 165 202.407 165 158.5C165 114.593 200.593 79 244.5 79C288.407 79 324 114.593 324 158.5ZM354 158.5C354 218.975 304.975 268 244.5 268C184.025 268 135 218.975 135 158.5C135 98.0248 184.025 49 244.5 49C304.975 49 354 98.0248 354 158.5Z",
    fill: "#E4E7EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye_closed.650cae6463f8d1b53c83d195d65502a8.svg";
export { ForwardRef as ReactComponent };